 
import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SMSService } from 'src/app/services/SMS/sms.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-birthday-alert',
  templateUrl: './birthday-alert.component.html',
  styleUrls: ['./birthday-alert.component.css']
})
export class BirthdayAlertComponent implements OnInit {



  Submitted: boolean = false;
  ClassList: any;
  SectionList: any;
  StudentDropDownList: any;
  StudentList: any;
  StaffList: any;
  GroupDropDownList: any;
  IndvGroupContactList: any;
  TemplateList: any;
  Group: any;
  Count1: number = 0;
  Count2: number = 0;
  Count3: number = 0;
  PersonList: any;
  GroupList: any;
  ContactSubmitted: boolean = false;
  GroupContactList: any;
  currentPage: number = 1;
  pageSize: number = 10;
  numberOfCharacters: any;
  SMSCount: any;
  FilePath:any;
  EmployeeTypeList:any;
  EmployeeCategoryList:any;
  DesignationList:any;
  DepartmentList:any;

  constructor(private SmsService: SMSService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  BirthdayAlertModel = {
    ClassID: 0,
    SendTypeID:1,
    SectionID: 0,
    StudentID: 0,
    TemplateID: 0,
    PersonTypeID: 0,
    GroupID: 0,
    EmployeeCategoryID: 0,
    EmployeeTypeID: 0,
    PrimaryDepartmentID: 0,
    DesignationID: 0,
    CurrentIndex: 0,
    PageSize: 0,
    Message: '',
    DLTTemplateID:'',
    IsFirstName: true,
    MessageType: "TEXT",
    Print:"",
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    BirthFromDate: moment(new Date()).format('DD-MMM-YYYY'),
    BirthToDate: moment(new Date()).format('DD-MMM-YYYY'),
  }

  ClearModel(){
    this.BirthdayAlertModel.ClassID=0;
    this.BirthdayAlertModel.SendTypeID=1;
    this.BirthdayAlertModel.SectionID=0;
    this.BirthdayAlertModel.StudentID=0;
    this.BirthdayAlertModel.TemplateID=0;
    this.BirthdayAlertModel.EmployeeCategoryID=0;
    this.BirthdayAlertModel.EmployeeTypeID=0;
    this.BirthdayAlertModel.PrimaryDepartmentID=0;
    this.BirthdayAlertModel.DesignationID=0;
    this.BirthdayAlertModel.Message='';
    this.BirthdayAlertModel.DLTTemplateID='';
    this.BirthdayAlertModel.FromDate=moment(new Date()).format('DD-MMM-YYYY');
    this.BirthdayAlertModel.ToDate=moment(new Date()).format('DD-MMM-YYYY');
    this.BirthdayAlertModel.BirthFromDate=moment(new Date()).format('DD-MMM-YYYY');
    this.BirthdayAlertModel.BirthToDate=moment(new Date()).format('DD-MMM-YYYY');
  }


  ChangePersonType() {
    this.StaffList = [];
    this.StudentList = [];
    this.GroupContactList = [];
    this.SelectModel.IsSelect = false;
    this.ClearModel();
    for (var i = 0; i < this.StudentList.length; i++) {

      this.StudentList[i].Active = false;

    }
    for (var i = 0; i < this.StaffList.length; i++) {
      this.StaffList[i].Active = false;

    }

    for (var i = 0; i < this.GroupContactList.length; i++) {
      this.GroupContactList[i].Active = false;

    }
  }


  // Student Details

  GetStudentDetails() {
    this.spinnerService.show();    
    this.BirthdayAlertModel.FromDate = this.BirthdayAlertModel.FromDate != null && this.BirthdayAlertModel.FromDate != '' ? moment(this.BirthdayAlertModel.FromDate).format('DD-MMM-YYYY') : '';
    this.BirthdayAlertModel.ToDate = this.BirthdayAlertModel.ToDate != null && this.BirthdayAlertModel.ToDate != '' ? moment(this.BirthdayAlertModel.ToDate).format('DD-MMM-YYYY') : '';
    this.SmsService.GetStudentforBithdayAlert(JSON.stringify(this.BirthdayAlertModel)).subscribe((data: any) => {
      this.StudentList = data.ListStuAdmission;
      this.spinnerService.hide();

    });
  };


  // Staff Details

  GetStaffDetails() {
    this.BirthdayAlertModel.BirthFromDate = this.BirthdayAlertModel.BirthFromDate != null && this.BirthdayAlertModel.BirthFromDate != '' ? moment(this.BirthdayAlertModel.BirthFromDate).format('DD-MMM-YYYY') : '';
    this.BirthdayAlertModel.BirthToDate = this.BirthdayAlertModel.BirthToDate != null && this.BirthdayAlertModel.BirthToDate != '' ? moment(this.BirthdayAlertModel.BirthToDate).format('DD-MMM-YYYY') : '';
    this.spinnerService.show();
    this.SmsService.GetStaffforBirthdayAlert(JSON.stringify(this.BirthdayAlertModel)).subscribe((data: any) => {
      this.StaffList = data.StaffList;
      this.spinnerService.hide();

    });
  }

  // Group Details

  GetGroupDetails() {
    this.GroupContactList = [];
    this.spinnerService.show();
    this.SmsService.GetBirtdayGroupDetails(JSON.stringify(this.BirthdayAlertModel)).subscribe((data: any) => {
      this.GroupContactList = data.GroupContactList;
      this.spinnerService.hide();

    });
  };


  GetGroupContact(item) {
    this.spinnerService.show();
    this.IndvGroupContactList = item.ContactList;
    if (this.IndvGroupContactList != null) {
      this.Group = item.GroupName;
    }
    this.spinnerService.hide();
  };
  AlbumPhoto= [];
  getFileDetails(e) {
    this.AlbumPhoto = [];
    for (var i = 0; i < e.target.files.length; i++) {  
      this.AlbumPhoto.push(e.target.files[i]) 
    }
  }

  SendBirthdayAlert() {
    this.PersonList = [];

    if (this.BirthdayAlertModel.PersonTypeID == 1) {
      this.spinnerService.show();
      for (var i = 0; i < this.StudentList.length; i++) {
        var Mobile = '';
        if (this.StudentList[i].Mobile != null && this.StudentList[i].IsSelect == true && Mobile == '') {
          Mobile = this.StudentList[i].Mobile;
        }
        else if (this.StudentList[i].Mobile != null && this.StudentList[i].IsSelect == true) {
          Mobile = Mobile + "," + this.StudentList[i].Mobile;
        }
        if (this.StudentList[i].FatherContactCell != null && this.StudentList[i].IsSelect == true && this.StudentList[i].IsFatherSelect == true) {
          Mobile = Mobile + "," + this.StudentList[i].FatherContactCell;
        }

        if (this.StudentList[i].MotherContactCell != null && this.StudentList[i].IsSelect == true && this.StudentList[i].IsMotherSelect == true) {

          Mobile = Mobile + "," + this.StudentList[i].MotherContactCell;
        }

        if (this.StudentList[i].IsSelect == true) {
          var item = {
            Mobile: Mobile,
            PersonID: this.StudentList[i].StudentID,
            AppRegID: this.StudentList[i].AppRegID,
            GRNo: this.StudentList[i].GRNo,
            Name: this.StudentList[i].Name,
          }
          this.PersonList.push(item);
        }

      }

      this.SmsService.SendBirthdayAlert(JSON.stringify(this.PersonList), JSON.stringify(this.BirthdayAlertModel),this.AlbumPhoto).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.spinnerService.hide();
        }
        this.globalHelper.CheckActionStatus(data);
      });
    }
    else if (this.BirthdayAlertModel.PersonTypeID == 2) {
      this.spinnerService.show();
      for (var i = 0; i < this.StaffList.length; i++) {
        if (this.StaffList[i].IsSelect == true) {
          let item = {
            Mobile: this.StaffList[i].Mobile,
            PersonID: this.StaffList[i].StaffID,
            AppRegID: this.StaffList[i].AppRegID,
            Gender: this.StaffList[i].Gender.toString().trim(),
            Name: this.StaffList[i].Name,
          }
          this.PersonList.push(item);
        }

      }

      this.SmsService.SendBirthdayAlert(JSON.stringify(this.PersonList),JSON.stringify(this.BirthdayAlertModel),this.AlbumPhoto).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.spinnerService.hide();
        }
        this.globalHelper.CheckActionStatus(data);
      });
    }

    else if (this.BirthdayAlertModel.PersonTypeID == 3) {
      this.spinnerService.show();
      this.GroupList = [];
      for (var i = 0; i < this.GroupContactList.length; i++) {
        if (this.GroupContactList[i].IsSelect == true) {
          if (this.GroupContactList[i].ContactList != null) {
            for (var j = 0; j < this.GroupContactList[i].ContactList.length; j++) {
              let item = {
                Mobile: this.GroupContactList[i].ContactList[j].Mobile,
                PersonID: this.GroupContactList[i].ContactList[j].ContactID,
                Name: this.GroupContactList[i].ContactList[j].Name,
              }
              this.PersonList.push(item);

            }

          }

        }

      }
      this.SmsService.SendBirthdayAlert(JSON.stringify(this.PersonList), JSON.stringify(this.BirthdayAlertModel),this.AlbumPhoto).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(data);
        }

      });
    }
  }
 

  ngOnInit() {

    if (this.globalHelper.GetLoginToken().IsSMSPackage) {
      this.BirthdayAlertModel.PersonTypeID = 3;
    }
    else {
      this.GetClass();
      this.GetEmployeeCategory();
      this.GetDesignation();
      this.GetDepartment();
      this.GetEmployeeType();
    }
    this.GetTemplate();
    this.GetAllGroup();
  }

  GetAllGroup() {
    this.LookupService.GetLookupsList('SMSGroup', '').subscribe((data: any) => {
      this.GroupDropDownList = data.LookupItems;
    });

  }

  GetClass() {
    this.LookupService.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetSection() {
    this.BirthdayAlertModel.SectionID = 0;
    this.BirthdayAlertModel.StudentID = 0;

    var itemBo = {
      'ItemId': this.BirthdayAlertModel.ClassID,

    };
    this.spinnerService.show();
    this.LookupService.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();
    });

  };

  GetStudent() {

    var itemBo = {
      'ItemId': this.BirthdayAlertModel.ClassID,
      'ItemId2': this.BirthdayAlertModel.SectionID
    };
    this.spinnerService.show();
    this.LookupService.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StudentDropDownList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetTemplate() {
    this.LookupService.GetLookupsList('SMSTemplate', '').subscribe((data: any) => {
      this.TemplateList = data.LookupItems;

    });
  };

  GetMessage() {
    this.spinnerService.show();
    for (var i = 0; i < this.TemplateList.length; i++) {

      if (this.TemplateList[i].ItemId == this.BirthdayAlertModel.TemplateID) {
        this.BirthdayAlertModel.Message = this.TemplateList[i].ItemCode1;
        this.BirthdayAlertModel.DLTTemplateID = this.TemplateList[i].DLTTemplateID;
        this.numberOfCharacters = this.BirthdayAlertModel.Message.length;
        this.SMSCount = Math.ceil(this.numberOfCharacters / 160);
      }


    }
    this.spinnerService.hide();
  }

  GetEmployeeType () {

    this.LookupService.GetLookupsList('EmployeeType', '').subscribe((data: any) => {
      this.EmployeeTypeList = data.LookupItems;
    });
  };

  GetDesignation() {

    this.LookupService.GetLookupsList('Designation', '').subscribe((data: any) => {
      this.DesignationList = data.LookupItems;
    });
  };

  GetDepartment() {
    this.LookupService.GetLookupsList('Department', '').subscribe((data: any) => {
      this.DepartmentList = data.LookupItems;
    });

  }

  GetEmployeeCategory() {
    this.LookupService.GetLookupsList('PersonnelType', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });

  }


  // Select-De Select
  SelectModel = {
    Active: false,
    IsSelect: false,
    FatherActive: false,
    MotherActive: false,
  };



  SelectAll() {

    if (this.SelectModel.Active && this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].IsSelect = true;

      }
    }
    if (this.SelectModel.Active == false && this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsSelect = false;

      }
    }
    if (this.SelectModel.FatherActive && this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].IsFatherSelect = true;

      }
    }
    if (this.SelectModel.FatherActive == false && this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsFatherSelect = false;

      }
    }

    if (this.SelectModel.MotherActive && this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].IsMotherSelect = true;

      }
    }
    if (this.SelectModel.MotherActive == false && this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsMotherSelect = false;

      }
    }
    if (this.SelectModel.Active && this.BirthdayAlertModel.PersonTypeID == 2) {
      for (var i = 0; i < this.StaffList.length; i++) {

        this.StaffList[i].IsSelect = true;

      }
    }
    if (this.SelectModel.Active == false && this.BirthdayAlertModel.PersonTypeID == 2) {
      for (var i = 0; i < this.StaffList.length; i++) {
        this.StaffList[i].IsSelect = false;

      }
    }
    if (this.SelectModel.Active && this.BirthdayAlertModel.PersonTypeID == 3) {
      for (var i = 0; i < this.GroupContactList.length; i++) {

        this.GroupContactList[i].IsSelect = true;

      }
    }
    if (this.SelectModel.Active == false && this.BirthdayAlertModel.PersonTypeID == 3) {
      for (var i = 0; i < this.GroupContactList.length; i++) {
        this.GroupContactList[i].IsSelect = false;

      }
    }

  }

  ChangeSelect(item) {
    this.Count1 = 0;
    this.Count2 = 0;
    this.Count3 = 0;
    if (this.BirthdayAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        if (this.StudentList[i].IsSelect) {
          this.Count1 = this.Count1 + 1;
        }
        if (this.StudentList[i].IsFatherSelect) {
          this.Count2 = this.Count2 + 1;
        }
        if (this.StudentList[i].IsMotherSelect) {
          this.Count3 = this.Count3 + 1;
        }
      }
      if (this.Count1 == this.StudentList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }
      if (this.Count2 == this.StudentList.length) {
        this.SelectModel.FatherActive = true;

      }
      else {
        this.SelectModel.FatherActive = false;
      }
      if (this.Count3 == this.StudentList.length) {
        this.SelectModel.MotherActive = true;

      }
      else {
        this.SelectModel.MotherActive = false;
      }

    }
    if (this.BirthdayAlertModel.PersonTypeID == 2) {
      for (var i = 0; i < this.StaffList.length; i++) {
        if (this.StaffList[i].IsSelect) {
          this.Count1 = this.Count1 + 1;

        }
      }
      if (this.Count1 == this.StaffList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }

    }
    if (this.BirthdayAlertModel.PersonTypeID == 3) {
      for (var i = 0; i < this.GroupContactList.length; i++) {
        if (this.GroupContactList[i].IsSelect) {
          this.Count1 = this.Count1 + 1;

        }
      }
      if (this.Count1 == this.GroupContactList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }

    }

  }

  // Download


  ContactListDownload() {
    this.JSONToCsvConverterContactList(this.IndvGroupContactList, 'Contact_List', true);
  };

  JSONToCsvConverterContactList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
      var row = "";
      row += 'Sr. No.' + ',';
      row += 'Group' + ',';
      row += 'Name' + ',';
      row += 'Mobile' + ',';
      row += 'DOB' + ',';
      row = row.slice(0, -1);
      CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
      var sno = i + 1;
      var row = "";
      row += '"' + sno + '",';
      row += '"' + this.Group + '",';

      if(arrayData[i].Name!=null){
        row += '"' + arrayData[i].Name + '",';
      }
      else{
        row += '"' + '' + '",';
      }
      if(arrayData[i].Mobile!=null){
        row += '"' + arrayData[i].Mobile + '",';
      }
      else{
        row += '"' + '' + '",';
      }
      if(arrayData[i].DOB!=null){
        row += '"' + moment( arrayData[i].DOB).format('DD-MMM-YYYY') + '",';
      }
      else{
        row += '"' + '' + '",';
      }
     

      row.slice(0, row.length - 1);
      CSV += row + '\r\n';
    }
    if (CSV == '') {
      alert('Invalid Data');
      return;
    }
    var FileName = ReportTitle + '_' + this.Group + '_' + moment(new Date()).format('DD-MMM-YYYY');

    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
  }


  XLSReport() {

   this.BirthdayAlertModel.Print = 'XLS';
   this.spinnerService.show();
    this.SmsService.GetStudentforBithdayAlert(JSON.stringify(this.BirthdayAlertModel)).subscribe((data: any) => {
            if (data.webResponse.Status) {
                this.FilePath = data.FilePath;
                window.location = data.FilePath;
            }
            this.spinnerService.hide();
        });
   
}


}